module.exports = "/_next/static/resources/single-fb1e1413294e9a29739d33e0dbe5d96e.jpg";